export const nameLocal = {
    token:"token"
}

